// 오퍼레이션 우측 탭을 위한 모듈 enum

export default {
  CHAT: 'CHAT',
  MESSAGE: 'MESSAGE',
  MAIL: 'MAIL',
  CHATBOT: 'CHATBOT',
  CALL: 'CALL'
}



// WEBPACK FOOTER //
// ./src/constants/moduleType.js